// Auth Types
export const STORE_USER = 'STORE_USER'
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT'
export const USER_EXPIRED = 'USER_EXPIRED'
export const STORE_USER_ERROR = 'STORE_USER_ERROR'
export const LOADING_USER = 'LOADING_USER'

// Filter and Table Types
export const FILTER_DATA = 'FILTER_DATA'
export const NOT_DIRECT_FILTER_DATA = 'NOT_DIRECT_FILTER_DATA'
export const SELECTED_MENU = 'SELECTED_MENU'
export const DATA_TABLE_PAYLOAD = 'DATA_TABLE_PAYLOAD'
export const EDIT_TABLE_PAYLOAD = "EDIT_TABLE_PAYLOAD"
export const EMPTY_EDIT_TABLE_PAYLOAD = "EMPTY_EDIT_TABLE_PAYLOAD"
export const ADD_PAYLOAD = 'ADD_PAYLOAD'
export const EMPTY_ADD_PAYLOAD = 'EMPTY_ADD_PAYLOAD'
export const EDIT_PAYLOAD = "EDIT_PAYLOAD"
export const EDIT_PAYLOAD_FAMILYGROUP = "EDIT_PAYLOAD"
export const EDIT_PAYLOAD_VOLUMETRICS = "EDIT_PAYLOAD_VOLUMETRICS"
export const EMPTY_PAYLOAD_FAMILYGROUP = "EMPTY_PAYLOAD"
export const SAVE_RESPONSE = "SAVE_RESPONSE"
export const DELETE_PAYLOAD = 'DELETE_PAYLOAD'
export const FAMILY_GROUP_SEARCH_PAYLOAD = 'FAMILY_GROUP_SEARCH_PAYLOAD'
export const SEARCH_PAYLOAD = 'SEARCH_PAYLOAD'
export const FAMILY_GROUP_MENU_HEADER_PAYLOAD = 'FAMILY_GROUP_MENU_HEADER_PAYLOAD'
export const PAGE_DIRTY_PAYLOAD = 'PAGE_DIRTY_PAYLOAD'
export const SEARCH_COUNT_PAYLOAD = 'SEARCH_COUNT_PAYLOAD'

// API Header Types
export const SET_AUTH_HEADER = 'SET_AUTH_HEADER'
export const CLEAR_AUTH_HEADER = 'CLEAR_AUTH_HEADER'
export const BEARER_PREFIX = 'Bearer'

// HTTP Methods - Using 'as const' for literal types
export const HTTP_METHOD_POST = 'POST' as const
export const HTTP_METHOD_GET = 'get' as const
export const HTTP_METHOD_GET_UPPER = 'GET' as const
export const HTTP_METHOD_PUT = 'PUT' as const
export const HTTP_METHOD_DELETE = 'DELETE' as const
export const HTTP_METHOD_PATCH = 'PATCH' as const
export const HTTP_METHOD_SEARCH = 'search' as const

// HTTP Method Type for IRequestParams
export type RequestMethodType = 'get' | 'search' | 'post'

// API Test Constants - Endpoints
export const TEST_API_ENDPOINT = '/api/test-endpoint'
export const TEST_CUSTOM_ENDPOINT = '/api/custom-endpoint'
export const TEST_SERVICE_ENDPOINT = '/api/data-service'
export const TEST_MASTER_DATA_ENDPOINT = '/api/master-data'

// API Test Constants - Headers
export const TEST_CONTENT_TYPE_HEADER = { 'Content-Type':  'application/json' }

// Test Token Constants (for axiosHeaders tests)
export const TEST_TOKEN = 'mock-token'
export const TEST_TOKEN_LONG = 'a'.repeat(72)
export const TEST_TOKEN_MIXED_CHARS = 'token_with-mixed_characters'
export const TEST_TOKEN_ALPHANUMERIC = 'abc123def456ghi789'
export const TEST_TOKEN_FIRST = 'first'
export const TEST_TOKEN_SECOND = 'second'
export const TEST_TOKEN_NUMERIC = 12345

// Test Payload Constants
export const TEST_PAYLOAD_ID = 1
export const TEST_PAYLOAD_NAME = 'Test Data'
export const TEST_PAYLOAD_SECOND_ID = 2
export const TEST_PAYLOAD_THIRD_ID = 3

// Test Response Constants
export const TEST_RESPONSE_SUCCESS = true
export const TEST_STATUS_OK = 'ok'

// Test Error Constants
export const TEST_ERROR_MESSAGE = 'Request failed'
export const TEST_NETWORK_ERROR = 'Network Error'

// Query Keys
export const QUERY_KEY_CREATE = 'create'
export const QUERY_KEY_PREFIX = 'key'

// Pagination Constants
export const TEST_SKIP_VALUE = 0
export const TEST_SKIP_VALUE_TEN = 10
export const TEST_TAKE_VALUE = 10
export const TEST_TAKE_VALUE_TWENTY = 20

// Filter Constants
export const TEST_FILTER_VALUE = 'status eq active'
export const TEST_FILTER_NAME = 'name eq test'
export const TEST_EMPTY_STRING = ''

// Response Type Constants
export const RESPONSE_TYPE_BLOB = 'blob'
export const RESPONSE_TYPE_JSON = 'json'

// Boolean Data Constants
export const BOOLEAN_LABEL_TRUE = 'True'
export const BOOLEAN_LABEL_FALSE = 'False'
export const BOOLEAN_VALUE_TRUE = true
export const BOOLEAN_VALUE_FALSE = false

// URL Query Parameters
export const QUERY_PARAM_SKIP = '$skip'
export const QUERY_PARAM_TOP = '$top'
export const QUERY_PARAM_FILTER = '$filter'
export const QUERY_PARAM_QUERY = 'query'
export const QUERY_PARAM_COUNT = 'count'

// Authorization Header Constants
export const AUTH_HEADER_KEY = 'Authorization'
export const AUTH_HEADER_COMMON = 'common'

// Test Data Arrays
export const TEST_ITEMS_ARRAY = [1, 2, 3]

// Null and Undefined Constants for Testing
export const TEST_NULL_VALUE = null
export const TEST_UNDEFINED_VALUE = undefined

// Numeric Test Values
export const TEST_ZERO_VALUE = 0
export const TEST_FALSE_VALUE = false